const MALFORMED_HTTP_HREF =
	/(href\s*=\s*["'])(https?:\/\/[^\s"'<>]+)(?:\s[^"']*)(["'])/gi;

/**
 * Older HTML posts can contain the publisher label inside an anchor's href,
 * for example `href="https://example.com/article Publisher"`. A literal space
 * is not valid in an HTTP URL, so retain the URL token and discard only that
 * accidental label suffix.
 */
export const normalizePostLinkHrefs = (html: string): string =>
	html.replace(MALFORMED_HTTP_HREF, "$1$2$3");
